
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/w/[slug]",
      function () {
        return require("private-next-pages/w/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/w/[slug]"])
      });
    }
  